define(function(require,exports){"use strict";exports.displayLoginAction=function(){return{restrict:"A",scope:{datauserstatus:"="},link:function(scope,element,attrs){1==scope.datauserstatus?element.addClass("show"):(element.addClass("hide"),element.remove())}}}});


// WEBPACK FOOTER //
// ./src/widget-hdfc-portal-navbar-advanced/scripts/directives.js